import React from "react";
import { SpecialtyDetailFootnote } from "@app/projects/results/adequacy";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface AdequacyDetailInfoTemplateProps {
  footnote: SpecialtyDetailFootnote;
  cmsCreditIsApplying: boolean;
  minProvidersFromRatio?: number | null;
}

// If updating the wording of this component, consider also updating NetworkCoverageMapCountyDetailInfo.tsx as the wording is the same, but styling is different.
const AdequacyDetailInfoTemplate: React.FC<AdequacyDetailInfoTemplateProps> = ({ footnote, cmsCreditIsApplying, minProvidersFromRatio }) => {
  if (!footnote) {
    return <></>;
  }

  const isPendingCounty = footnote.geographyStatus === "Pending" && footnote.geographyType === "county";
  const passPercentage = cmsCreditIsApplying && isPendingCounty ? footnote?.passPercentageWithCMSAppCreditPercentage : footnote?.passPercentage;

  const providerRegionTypePhrase = footnote.providerRegionTypePhrase !== "" ? (
    <>
      <strong className="text-warning"> {minProvidersFromRatio ?? footnote.requiredServicingCount} {footnote.specialtyGroupName} {footnote.servicingEntityType}</strong> {footnote.providerRegionTypePhrase}
    </>
  ) : <></>;

  const templateCriteriaBody = footnote.skipAccessTimeAndDistance ? (
    <> {footnote.geographyType} where networks are required to have
      {providerRegionTypePhrase}.
    </>
  ) : (
    <> {footnote.geographyType} where networks are required to cover {passPercentage}% of the beneficiaries with access to
      <strong className="text-warning"> {footnote.minimumProviderCount} {footnote.specialtyGroupName} {footnote.entityType}</strong> within
      <strong><span className="text-info"> {footnote.minimumDistancePhrase}</span></strong>{footnote.accessOverride ? " (access customization)" : ""}
      {footnote.providerRegionTypePhrase !== "" ? " and " : ""}
      {providerRegionTypePhrase}.
    </>
  );

  return (
    <>
      <hr className="mt0" />
      <p className="small">
        <QesIcon iconName={QesIcons.InfoCircle} isDecorative className="align-text-top mr5" />
        <strong>{footnote.geographyName}</strong> is a
        <span className="text-warning">{footnote.geographyClass ? ` ${footnote.geographyClass}` : ""}</span>
        {templateCriteriaBody}
      </p>
    </>
  );
};

export default AdequacyDetailInfoTemplate;
